// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"165":"forum/native/addFirebasePushNotifications","689":"forum/share/addShareControls","996":"forum/components/NotificationsHelpPage"}[chunkId] + ".js";
};